import { ChevronDownIcon } from '@primer/octicons-react';
import { Box, Button, SelectPanel } from '@primer/react';
import { useMemo, useState } from 'react';

type CrmSurveyComboBoxStaticProps = {
    options: Array<{ id: number; text: string }>;
    value?: number;
    onValueChanged: (id: number, data?: { id: number; text: string }) => void;
    width?: string | number;
    isShowClearButton?: boolean;
    align?: "left" | "right";
    placeholder?: string;
};

const CrmSurveyComboBoxStatic: React.FC<CrmSurveyComboBoxStaticProps> = (props) => {
    const [open, setOpen] = useState(false);
    const [filter, setFilter] = useState('');

    const filteredItems = useMemo(() => {
        const safeData = Array.isArray(props.options) ? props.options : [];
        return safeData.filter(item => 
            item.text?.toLowerCase().includes(filter.toLowerCase())
        );
    }, [props.options, filter]);

    const selected = useMemo(() => {
        const safeData = Array.isArray(props.options) ? props.options : [];
        return safeData.find(x => x.id === props.value);
    }, [props.options, props.value]);

    const setSelected = (selecteds: any) => {
        if (selecteds) {
            props.onValueChanged(selecteds.id, selecteds);
        }
    };

    return (
        <SelectPanel
            renderAnchor={({ children, 'aria-labelledby': ariaLabelledBy, ...anchorProps }) => (
                <Box sx={{ display: "flex" }}>
                    <Button
                        sx={{
                            width: "-webkit-fill-available",
                        }}
                        trailingAction={ChevronDownIcon}
                        aria-labelledby={`${ariaLabelledBy}`}
                        {...anchorProps}
                        className={props.align ? `button-${props.align}` : ''}
                    >
                        <p
                            style={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                            }}
                        >
                            {(selected && selected.text) ? selected.text : (props.placeholder || 'Chọn')}
                        </p>
                    </Button>
                </Box>
            )}
            title={<Box sx={{ display: "flex", flexDirection: "row-reverse" }}>
                {props.isShowClearButton && props.value !== undefined && props.value > 0 && (
                    <Button
                        variant="invisible"
                        size="small"
                        onClick={() => {
                            props.onValueChanged(0, undefined);
                        }}
                    >
                        Xóa
                    </Button>
                )}
            </Box>}
            placeholderText="Tìm kiếm"
            open={open}
            onOpenChange={setOpen}
            items={filteredItems}
            selected={selected}
            onSelectedChange={setSelected}
            onFilterChange={setFilter}
            showItemDividers={true}
            overlayProps={{ width: 'medium', height: 'medium' }}
        />
    );
};

export default CrmSurveyComboBoxStatic;
